import { render, staticRenderFns } from "./MatrixSyllabuses.vue?vue&type=template&id=12146c01&scoped=true&"
import script from "./MatrixSyllabuses.vue?vue&type=script&lang=js&"
export * from "./MatrixSyllabuses.vue?vue&type=script&lang=js&"
import style0 from "./MatrixSyllabuses.vue?vue&type=style&index=0&id=12146c01&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12146c01",
  null
  
)

export default component.exports